import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";
import {
  Language,
  LANGUAGE_CODES,
  LANGUAGE_NAMES,
  LANGUAGES,
  toLanguage,
} from "locales/constants";
import { useChooseLanguage } from "hooks/useLanguage";

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const current = toLanguage(i18n.language);
  const chooseLanguage = useChooseLanguage();

  const choose = (language: Language) => {
    setAnchor(null);
    chooseLanguage(language);
  };

  return (
    <>
      <Button
        color="inherit"
        startIcon={<TranslateIcon fontSize="small" />}
        aria-label={t("language.label")}
        aria-haspopup="menu"
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{ minWidth: "auto", flexShrink: 0 }}
      >
        {LANGUAGE_CODES[current]}
      </Button>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        {LANGUAGES.map((language) => (
          <MenuItem
            key={language}
            lang={language}
            selected={language === current}
            onClick={() => choose(language)}
          >
            {LANGUAGE_NAMES[language]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
